<cf-frontend-sdk-cplace-control-skeleton
  [componentId]="componentId"
  [label]="label"
  [labelPosition]="labelPosition"
  [labelFor]="nativeFormComponentId"
  [validationMessage]="validationMessage"
  [validationSeverity]="validationSeverity"
  [alert]="alert"
  [required]="required"
  [readonly]="readonly"
  [disabled]="disabled"
>
  <p-checkbox
    [inputId]="nativeFormComponentId"
    [binary]="true"
    [disabled]="disabled || readonly"
    [(ngModel)]="value"
    (ngModelChange)="onSubmit()"
    [attr.aria-required]="required"
    [attr.aria-disabled]="disabled"
    [attr.aria-invalid]="validationSeverity !== 'info'"
  >
  </p-checkbox>
</cf-frontend-sdk-cplace-control-skeleton>
